import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";
import { translateText } from 'app/requests/translate';
import { speakText } from 'app/utils/speak';
import { useRouter } from 'next/router';
import { useState } from 'react';

const ChatMessage = ({ message, isUser }) => {
  const router = useRouter();
  const [textTranslated, setTextTranslated] = useState('');
  const [openTranslate, setOpenTranslate] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleTranslate = async () => {
    setOpenTranslate(true);
    setLoading(true);

    if (!textTranslated) {
      const dataTranslate = {
        text: message.content,
        to: router.locale,
        settings: {
          without_english: false,
        }
      }
      const result = await translateText(dataTranslate);
      setTextTranslated(result);
    }

    setLoading(false);
  }

  return (
    <div className={`d-flex ${isUser ? 'justify-content-end' : 'justify-content-start'} mb-3`}>
      <div className={`d-flex ${isUser ? 'flex-row-reverse' : 'flex-row'} align-items-end w-90`}>
        <div
          style={{ borderRadius: 20 }}
          className={`p-2 px-3 ${isUser ? 'bg-primary text-white rounded-bottom-end-0' : 'bg-light shadow-sm text-dark rounded-bottom-start-0'}`}
        >
          {message.content}
          {!isUser &&
            <FontAwesomeIcon
              icon={faVolumeUp}
              onClick={() => speakText(message.content, 'en')}
              className='ml-2 cursor-pointer'
            />
          }
          {!isUser && router.locale != 'en' &&
            <img
              onClick={() => handleTranslate()}
              className='ml-2 cursor-pointer'
              width={22} src={`/images/${loading ? 'commons/gif/loading.gif' : 'translates/text.png'}`}
            />
          }
          {textTranslated && openTranslate &&
            <div className="mt-2">
              <i>{textTranslated}</i>
              <i
                onClick={() => setOpenTranslate(false)}
                className='ml-2 text-info cursor-pointer text-decoration-underline'>
                Hidden
              </i>
            </div>
          }
        </div>
      </div>
    </div>
  )
};

export default ChatMessage;
